import { useState, DragEvent, ReactNode } from 'react';

export interface BaseItemProps {
  id: string;
  image: string;
  title: string;
  isObtained: boolean;
  displayName?: boolean;
  tooltip?: string;
  shadow?: boolean;
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
  onRightClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
  childItem?: string;
  displayChildItem?: boolean;
  overlay?: ReactNode;
}

export function BaseItem(props: BaseItemProps) {
  const [childItem, setChildItem] = useState<string | undefined>(props.childItem);

  const onDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    try {
      const data = JSON.parse(e.dataTransfer.getData('text/plain'));
      if (data?.img) setChildItem(data.img);
    } catch { /* ignore invalid drops */ }
  };

  const onDragStart = (e: DragEvent<HTMLImageElement>) => {
    e.dataTransfer.setData('text/plain', JSON.stringify({
      img: props.image,
      name: props.title,
      tags: [],
      childImage: childItem,
    }));
  };

  return (
    <div
      className="relative flex flex-col items-center justify-center select-none"
      onDragOver={(e) => e.preventDefault()}
      onDrop={onDrop}
      title={props.tooltip ?? props.title}
    >
      <div className={`flex items-center justify-center ${!props.isObtained ? 'brightness-[0.35]' : ''} transition-[filter] duration-150`}>
        <img
          draggable
          onDragStart={onDragStart}
          src={props.image}
          alt={props.title}
          className="w-8 h-8 cursor-pointer"
          onClick={props.onClick}
          onContextMenu={props.onRightClick}
        />
      </div>

      {props.displayName && (
        <span className="text-[10px] text-center w-8 leading-tight mt-0.5 text-gray-300">
          {props.title}
        </span>
      )}

      {/* Overlay (upgrade label, counter, etc.) */}
      {props.overlay}

      {/* Child item overlay (from drag-and-drop) */}
      {childItem && props.displayChildItem && (
        <img
          src={childItem}
          alt="child"
          className="absolute -bottom-2 left-2 w-4 h-4 cursor-pointer"
          onContextMenu={(e) => { e.preventDefault(); setChildItem(undefined); }}
        />
      )}
    </div>
  );
}
